/* Built In Imports */
/* External Imports */
import { Box, Heading, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import SimpleButton from '@msr/components/Buttons/SimpleButton';
import StructuredTextParser from '@msr/Utility/StructuredTextParser';

/* Services */

/**
 * Renders the Attend In Person Banner Section component
 *
 * @param {object} sectionContent - Data for section      justifyContent="center"

 * @param {string} region - Region for the Section
 * @param {string} lang - Language for the Section
 * @returns {ReactElement} - AttendInPersonBanner Section Component
 */

export const AttendInPersonBannerV2 = ({ section, lang }) => {
  return (
    <Box
      backgroundImage={{
        base: section.sectionContent[0]?.mobileImage?.url,
        sm: section.sectionContent[0]?.desktopImage?.url,
      }}
      bgSize={{ base: 'cover', sm: 'cover', xl: 'contain' }}
      bgPos={{ base: 'top', lg: 'center', '2xl': 'center' }}
      bgRepeat="no-repeat"
      width="100%"
      position="relative"
      height={{ base: 'auto', sm: '663px', md: '639px', lg: '639px' }}
      display="flex"
      flexDir="column"
      justifyContent="center"
      backgroundColor={'#E5F5FF'}
      marginBottom={'0px'}
      backgroundPosition={'top right'}
    >
      <Box className="page-wrap">
        <Box
          display={{ base: 'block', md: 'none' }}
          position="relative"
          height={{ base: '270px', sm: 'auto' }}
          backgroundSize="cover"
          backgroundPosition="center"
        />
        <Box
          maxW={{ base: '100%', sm: '56%', md: '420px', lg: '460px' }}
          mx={{ base: 'auto', sm: '20px', md: 'initial' }}
          zIndex={1}
          ml={{ base: 'auto', sm: '30px', md: '5%', lg: '5%' }}
          p={{ base: '0 16px', md: '0' }}
        >
          <Heading
            as="h1"
            mt={{base:'30px', md:''}}
            mb={{ base: '5px', sm: '5px', md: '30px' }}
            fontFamily={lang === 'ta' ? 'MuktaMalar' : 'FedraSerifAStdBook'}
            fontStyle="normal"
            fontWeight={lang == 'ta' ? '700' : '600'}
            fontSize={
              lang == 'ta'
                ? { base: '26px', md: '40px' }
                : { base: '26px', md: '36px', lg: '40px' }
            }
            color="#000000"
          >
            {section?.sectionContent[0]?.title}
          </Heading>
          <Heading
            as="h4"
            fontFamily={lang === 'ta' ? 'MuktaMalar' : 'FedraSansStd-medium'}
            fontStyle="normal"
            fontWeight={lang == 'ta' ? '500' : '500'}
            fontSize={'18px'}
            color="#873102"
            mb={{ base: '20px', sm: '10px', md: '30px' }}
          >
            {
              section?.sectionContent[0]?.description?.value?.document
                ?.children[0]?.children[0]?.value
            }{' '}
            <br />
            {
              section?.sectionContent[0]?.description?.value?.document
                ?.children[1]?.children[0]?.value
            }
          </Heading>
          <Text
            as="p"
            fontStyle="normal"
            fontWeight={{ base: '400', md: lang == 'ta' ? '400' : '350' }}
            color="#000000"
            mb={{ base: '20px', sm: '20px', md: '30px' }}
            ml="-8px"
            maxW={{ base: '100%', md: '70%' }}
            sx={{
              p: {
                fontSize: lang == 'ta' ? { base: '16px' } : { base: '16px' },
              },
            }}
          >
            <StructuredTextParser
              str={render(section?.sectionContent[0]?.bottomText)}
              color="#000000"
              fontFamily={lang == 'ta' ? 'MuktaMalar' : 'FedraSansStd-book'}
              pageName="tamilthembu"
            />
          </Text>

          <SimpleButton
            style={section?.sectionContent[0].button[0]}
            region={''}
            lang={lang}
            mb={{ base: '20px', sm: '20px', md: '0px', lg: '0px' }}
            height={'56px'}
            width={'151px'}
          />
        </Box>
      </Box>
      <style jsx global>
        {`
          @media (max-width: 768px) {
            #attend-in-person-banner-2025 h1 {
              margin-top: 45px !important;
            }
          }
          @media (max-width: 360px) {
            #attend-in-person-banner-2025 h1 {
              margin-top: 0px !important;
            }
          }
        `}
      </style>
    </Box>
  );
};
